import React from "react";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import LoginPinForm from "../../components/profile/LoginPinForm";
import PasswordChangeForm from "../../components/profile/PasswordChangeForm";
import SessionManager from "../../components/profile/SessionManager";
import UserProfileForm from "../../components/profile/UserProfileForm";
import { route } from "../../static/route";
import { BreadcrumbType } from "../../types/common";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "પ્રોફાઇલ સેટિંગ્સ" },
];

const ProfilePage = () => {
  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className="font-semibold text-xl md:text-2xl text-[#113F67]">
          પ્રોફાઇલ સેટિંગ્સ
        </h1>
      </div>

      <div className="flex flex-col gap-6">
        <UserProfileForm />

        <PasswordChangeForm />

        <LoginPinForm />

        <SessionManager />
      </div>
    </AppLayout>
  );
};
export default ProfilePage;
